import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@material-ui/core';
import Loader from 'sharedComponents/Loader';
import Icon from 'sharedComponents/Icon';
import ReactPlayer from 'react-player/lazy';

import useStyles from './useStyles';

const DEFAILT_WIDTH = '549';
const RESOLUTION_RATIO = 9 / 16;

const VideoPlayer = props => {
  const { url, className, width, disabled, autoplay } = props;
  const classes = useStyles();
  const height = (Number.parseInt(width, 10) * RESOLUTION_RATIO).toFixed();

  const INITIAL_PLAYER_STATE = {
    playing: autoplay,
    finished: false,
    initialized: false,
    loading: false,
    resolution: { width, height },
    hiddenControl: false,
  };

  const [state, setState] = useState(INITIAL_PLAYER_STATE);
  const playerRef = useRef(null);

  if (playerRef.current && playerRef.current.getInternalPlayer() && !state.initialized) {
    const { videoWidth, videoHeight } = playerRef.current.getInternalPlayer();
    const vWidth = Number.parseInt(height, 10).toFixed();
    const vHeight = Number.parseInt(width, 10).toFixed();
    if (videoWidth && videoHeight) {
      const resolution = videoWidth > videoHeight ? { width, height } : { width: vWidth, height: vHeight };
      setState({ ...state, resolution, initialized: true });
    }
  }

  const playerStyle = {
    width: `${state.resolution.width}px`,
    height: `${state.resolution.height}px`,
  };

  const handleFinish = () => {
    setState({ ...state, playing: false, finished: true });
  };

  const handleWaiting = () => {
    setState({ ...state, loading: true });
  };

  const handleCanPlay = () => {
    setState({ ...state, loading: false });
  };

  const handleClickPlay = () => {
    setState({ ...state, playing: true });
  };

  const handleClickPause = () => {
    setState({ ...state, playing: false });
  };

  const handleMouseOver = () => {
    setState({ ...state, hiddenControl: false });
  };

  const handleMouseOut = () => {
    setState({ ...state, hiddenControl: true });
  };

  const handler = state.playing ? handleClickPause : handleClickPlay;
  const iconName = state.playing ? 'pause' : 'play';
  const hidden = (state.playing && state.hiddenControl) || state.loading || disabled;

  return (
    <Box
      style={playerStyle}
      className={clsx(className, classes.paper)}
      onMouseOver={handleMouseOver}
      onFocus={handleMouseOver}
      onMouseOut={handleMouseOut}
      onBlur={handleMouseOut}
    >
      <Box hidden={!state.initialized} className={clsx(classes.playerWrapper, { [classes.blured]: disabled })}>
        <ReactPlayer
          width="100%"
          height="100%"
          url={url}
          ref={playerRef}
          playing={state.playing}
          className={classes.player}
          onEnded={handleFinish}
          onBuffer={handleWaiting}
          onReady={handleCanPlay}
          playsInline
        />
        <IconButton onClick={handler} className={clsx(classes.playerButtons, { [classes.hidden]: hidden })}>
          <Icon name={iconName} />
        </IconButton>
        {state.loading && <Loader />}
      </Box>
      {!state.initialized && <Loader />}
    </Box>
  );
};

VideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  autoplay: PropTypes.bool,
};

VideoPlayer.defaultProps = {
  className: '',
  width: DEFAILT_WIDTH,
  disabled: false,
  autoplay: false,
};

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoPlayer/VideoPlayer.js